/** Client helpers for masked brokerage tokens (issue #48). */

const MASK_PREFIX = '****';

export function isMaskedCredential(value) {
  if (!value || typeof value !== 'string') return false;
  return value.trim().startsWith(MASK_PREFIX);
}

/** UI bullet placeholder shown in password fields when a token exists but is hidden. */
export function isBulletPlaceholder(value) {
  if (!value || typeof value !== 'string') return false;
  const t = value.trim();
  return t.length > 0 && /^[•*]+$/.test(t);
}

/** Whether a mapping/configuration save should include a new apiToken/tradierToken. */
export function shouldSendCredentialOnSave(value) {
  if (!value || typeof value !== 'string') return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return !isMaskedCredential(trimmed) && !isBulletPlaceholder(trimmed);
}
